<template>
  <el-card shadow="never" class="common-container">
    <div slot="header" class="meteria-card-header">
      <div class="btn-wrap">
        {{
          materialType === CONST.MATERIAL_TYPE.img
            ? $t('shopDecoration.multimediaMaterial.selectPic')
            : $t('shopDecoration.multimediaMaterial.selectVideo')
        }}
        <router-link :to="{ name: 'multimedia-material' }">
          <el-link class="title-info" type="primary" :underline="false">
            素材管理
          </el-link>
        </router-link>
      </div>

      <div class="search-wrap">
        <el-input
          v-model="searchInput"
          :placeholder="`${materialTypeName}名称`"
          class="input-with-select"
          @keyup.enter.native="handleSeach"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleSeach"
          ></el-button>
        </el-input>
      </div>
    </div>
    <!-- 左侧内容 -->
    <div>
      <!-- 内容 -->
      <div class="all-content-wrap">
        <!-- 分组列表 -->
        <div class="groups-wrap">
          <material-group-wrap
            ref="materiaGroupWrap"
            :material-type="materialType"
            :groups-list="groupsList"
            :disabled="true"
            :select-group="selectGroup"
            @selectGroup="handleselectGroup"
            @addGroup="addGroup"
          ></material-group-wrap>
          <div class="add-btn">
            <el-button plain type="primary" @click="handleAddItem">
              {{
                materialType === CONST.MATERIAL_TYPE.img
                  ? $t('shopDecoration.multimediaMaterial.uploadPic')
                  : $t('shopDecoration.multimediaMaterial.uploadVideo')
              }}
            </el-button>
          </div>
        </div>
        <!-- 素材列表 -->
        <div class="material-wrap">
          <template v-if="list.length">
            <div class="material-list">
              <div
                v-for="item in list"
                :key="item.id"
                class="item"
                @click="handleSelectItem(item)"
              >
                <material-item-in-list
                  :item="item"
                  :sort="getSelectSort(item.id)"
                  :show-sort="showSort"
                  :selected="isItemSelected(item)"
                ></material-item-in-list>
                <div class="name-wrap">
                  <div class="name" :title="item.materialName">
                    {{ item.materialName }}
                  </div>
                </div>
              </div>
            </div>
            <el-pagination
              class="common-pagination-box"
              :current-page="page.current"
              :page-size="page.pageLimit"
              :page-sizes="page.pageSizes"
              :layout="page.layout"
              :total="page.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </template>
          <template v-else>
            <div class="no-data-wrap">暂无数据</div>
          </template>
        </div>
      </div>
    </div>

    <add-img-dialog
      v-if="materialType === CONST.MATERIAL_TYPE.img"
      ref="addItemDialog"
      :groups-list="groupsList"
      :edit-item="curEditItem"
      @edited="initByMaterialEdited"
    />

    <add-video-dialog
      v-if="materialType === CONST.MATERIAL_TYPE.video"
      ref="addItemDialog"
      :groups-list="groupsList"
      :edit-item="curEditItem"
      @edited="initByMaterialEdited"
    />
  </el-card>
</template>
<script>
import AddVideoDialog from '../add-video-dialog.vue';
import AddImgDialog from '../add-img-dialog.vue';
import MaterialItemInList from './material-item-in-list.vue';
import MaterialGroupWrap from './material-group/material-group-wrap.vue';
import SearchTableMixin from '@/mixins/search-table';
import { mapGetters } from 'vuex';
/**
 * 素材管理
 * 视频和图片差异较小，只在这里区分这些差异，后续如果差异变大，需要拆分组件重新组合
 */
export default {
  components: {
    MaterialGroupWrap,
    MaterialItemInList,
    AddImgDialog,
    AddVideoDialog,
  },
  mixins: [SearchTableMixin(false)],
  props: {
    materialType: {
      type: Number,
      required: true,
    },
    limit: {
      type: Number,
      required: true,
    },
    // 为了区别返回值是否是数组, 兼容之前的用法
    isMulti: {
      type: Boolean,
      default: false,
    },
    showSort: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      curSelectList: [],
      searchInput: '',
      list: [],
      groupsList: [],
      selectGroup: undefined,
      CONST,
      curEditItem: _.cloneDeep(CONST.DEF_MATERIAL_ITEM),
    };
  },

  computed: {
    materialTypeName() {
      return this.materialType === CONST.MATERIAL_TYPE.img ? '图片' : '视频';
    },
    ...mapGetters(['sellerBookingType', 'yyStoreId']),
    requestPre() {
      return this.sellerBookingType === 1 ? '/bookingAdmin' : '';
    },
  },
  mounted() {
    this.initAllData();
  },
  methods: {
    addGroup() {
      this.initGroupData();
    },
    clear() {
      this.curSelectList = [];
    },
    isItemSelected(item) {
      return this.curSelectList.map(t => t.id).includes(item.id);
    },
    getSelectSort: function(curId) {
      const index = this.curSelectList
        .map(material => material.id)
        .findIndex(id => id === curId);
      return index > -1 ? index + 1 : index;
    },
    handleselectGroup(id) {
      this.searchInput = '';
      this.page.current = 1;
      this.selectGroup = id;
      this.initData();
    },

    handleSeach() {
      this.selectGroup = null;
      this.page.current = 1;
      this.initData();
    },
    initData() {
      this.$http
        .post(
          `${this.requestPre}/sellerMaterial/query`,
          {
            materialName: this.searchInput,
            ...this.pageParams4Api,
            type: this.materialType,
            meterialGroupId: this.selectGroup,
          },
          {
            showLoading: true,
            catchBusinessErr: true,
          }
        )
        .then(res => {
          const { data } = res.data;
          const { records, total } = data;
          this.list = records;
          this.page.total = total;
        });
    },
    initGroupData() {
      this.$http
        .post(
          `${this.requestPre}/materialGroup/query`,
          {
            size: 999,
            current: 1,
            type: this.materialType,
          },
          {
            catchBusinessErr: true,
          }
        )
        .then(res => {
          this.groupsList = res.data.data;
        });
    },
    // 图片修改-刷新除了分组
    initByMaterialEdited() {
      this.page.current = 1;
      this.searchInput = '';
      this.initData();
      this.initGroupData();
    },
    // 所有状态刷新 包括分组
    initAllData() {
      this.page.current = 1;
      this.searchInput = '';
      this.selectGroup = null;
      this.initData();
      this.initGroupData();
    },
    handleSelectItem(item) {
      if (this.isMulti) {
        // 多选
        const tmp = _.xorBy(this.curSelectList, [item], 'id');
        // 是否超过最大值
        if (tmp.length > this.limit) {
          return;
        }
        this.curSelectList = tmp;
      } else {
        this.curSelectList = [item];
      }
    },
    handleAddItem() {
      this.curEditItem = Object.assign({}, CONST.DEF_MATERIAL_ITEM);
      this.$refs.addItemDialog.open();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';

.meteria-card-header {
  display: flex;
  .btn-wrap {
    display: flex;
    align-items: center;
    > div {
      margin-left: 15px;
    }
  }
  .search-wrap {
    text-align: right;
    flex: 1;
    .el-input-group {
      min-width: 220px;
      width: 50%;
    }
  }
}

.all-content-wrap {
  display: flex;
  .material-wrap {
    margin-left: 25px;
    flex: 1;
  }
  .groups-wrap {
    width: 340px;
    display: flex;
    flex-direction: column;
    .add-btn {
      height: 60px;
      line-height: 60px;
      text-align: center;
    }
  }
}

.material-list {
  min-height: 50vh;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  @include scrollBar;
  display: flex;
  flex-wrap: wrap;
  .item {
    display: flex;
    flex-direction: column;
    margin-right: 15px;
    margin-bottom: 15px;
    width: 140px;
    cursor: pointer;
    .name-wrap {
      display: flex;
      .name {
        @include overflowWords;
        flex: 1;
        font-size: 14px;
      }
    }
  }
}

.no-data-wrap {
  padding: 20px 0;
  font-size: 16px;
  text-align: center;
  color: #333;
}

.group-list-tree {
  max-height: calc(100vh - 400px);
  overflow-y: auto;
  @include scrollBar;
}
</style>
